import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';

/**
 * Fixed full-viewport overlay that centers its content.
 * Shared by {@link LoadingFullPage} and {@link MessageFullPage}.
 */
export const FullPage = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.BACKGROUND};
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;
